// Helpers puros pra timeline de follow-ups do funil — sem i18n, sem Vue.
// Quem consome (FollowUpStepCard/FollowUpTimeline) monta o texto final via
// $t(...) usando os números que estas funções retornam.

/**
 * Formata um intervalo em horas como '7d', '2h' ou '7d 2h'.
 * @param {number} hours
 * @returns {string}
 */
export const formatDelay = hours => {
  const total = Math.max(0, Math.round(Number(hours) || 0));
  const days = Math.floor(total / 24);
  const remainingHours = total % 24;

  if (days === 0) return `${remainingHours}h`;
  if (remainingHours === 0) return `${days}d`;
  return `${days}d ${remainingHours}h`;
};

/**
 * Converte horas acumuladas no "dia" da jornada (1-based), arredondando
 * pra cima quando sobram horas soltas (170h -> dia 8).
 * @param {number} hours
 * @returns {number}
 */
export const cumulativeDay = hours => {
  const total = Math.max(0, Number(hours) || 0);
  return Math.ceil(total / 24);
};

const VARIABLE_PATTERN = /(\{\{[^{}]+\}\})/g;
const IS_VARIABLE = /^\{\{[^{}]+\}\}$/;

/**
 * Quebra um texto com placeholders `{{var}}` em tokens { type, value } pra
 * renderizar chips sem v-html.
 * @param {string} text
 * @returns {Array<{type: 'text'|'var', value: string}>}
 */
export const highlightVariables = text => {
  const str = text || '';
  if (!str) return [];

  return str
    .split(VARIABLE_PATTERN)
    .filter(part => part !== '')
    .map(part => ({
      type: IS_VARIABLE.test(part) ? 'var' : 'text',
      value: part,
    }));
};
